/*
 * Better Turns POS System
 * Copyright (c) 2024 Better Turns LLC
 * All rights reserved.
 *
 * Author: Gabe Mohacsi
 * Description: Layout Page for the Better Turns Retail Site.
 * License: Proprietary - Redistribution, modification, or use without
 * explicit permission from Better Turns LLC is prohibited.
 */

import React from 'react';
import Footer from './Footer';
import Header from './Header';

const Layout = ({ children }) => {
  return (
    <div className="flex flex-col min-h-screen bg-white text-deep-navy">
      {/* Header */}
      <Header />

      {/* Main content */}
      <main className="flex-1 container mx-auto px-4 py-8">{children}</main>

      {/* Footer */}
      <Footer />
    </div>
  );
};

export default Layout;
